/*
 * Constants.
 */

const legacyAppRoutePrefixes = [
  '/settings',
  '/analytics2',
  '/contacts',
  '/activities',
  '/calendar',
  '/analytics',
  '/contacts-manager',
];

/*
 * Helpers.
 */

/** @deprecated Avoid dealing with URLs directly */
export function isLegacyPath(path: string) {
  return legacyAppRoutePrefixes.some((p) => path.startsWith(p));
}
